import { MessageConfigType } from '../../types';
import {
  ASSETS_SUB_MENU_LIST,
  CALL_AI_SUB_MENU_LIST,
  COACHING_SUB_MENU_LIST,
  DSR_SUB_MENU_LIST,
  NAVIGATION_MENU_LIST,
  TEAM_ANALYTICS_SUB_MENU_LIST,
  TRAINING_SUB_MENU_LIST,
} from './enum';
import messages from './messages';

const navigationMessagesConfig: MessageConfigType = {
  [NAVIGATION_MENU_LIST.HOME]: {
    expandedName: messages.HOME,
    collapsedName: messages.HOME,
    subMenuName: {},
  },
  [NAVIGATION_MENU_LIST.ASSISTANT]: {
    expandedName: messages.ASSISTANT,
    collapsedName: messages.ASSISTANT,
    subMenuName: {},
  },
  [NAVIGATION_MENU_LIST.TRAINING]: {
    expandedName: messages.TRAINING,
    collapsedName: messages.TRAINING,
    subMenuName: {
      [TRAINING_SUB_MENU_LIST.TRAINING_SERIES]: {
        expandedName: messages.TRAINING_SERIES,
        collapsedName: messages.TRAINING_SERIES,
      },
      [TRAINING_SUB_MENU_LIST.TRAINING_MODULES]: {
        expandedName: messages.TRAINING_MODULES,
        collapsedName: messages.TRAINING_MODULES,
      },
      [TRAINING_SUB_MENU_LIST.TRAINING_ILT_SESSIONS]: {
        expandedName: messages.TRAINING_ILT_SESSIONS,
        collapsedName: messages.TRAINING_ILT_SESSIONS,
      },
      [TRAINING_SUB_MENU_LIST.TRAINING_LEADERBOARD]: {
        expandedName: messages.TRAINING_LEADERBOARD,
        collapsedName: messages.TRAINING_LEADERBOARD,
      },
      [TRAINING_SUB_MENU_LIST.TRAINING_TASKS]: {
        expandedName: messages.TRAINING_TASKS,
        collapsedName: messages.TRAINING_TASKS,
      },
      [TRAINING_SUB_MENU_LIST.TRAINING_FILES]: {
        expandedName: messages.TRAINING_FILES,
        collapsedName: messages.TRAINING_FILES,
      },
      [TRAINING_SUB_MENU_LIST.TRAINING_AI_TUTORIALS]: {
        expandedName: messages.TRAINING_AI_TUTORIALS,
        collapsedName: messages.TRAINING_AI_TUTORIALS,
      },
    },
  },
  [NAVIGATION_MENU_LIST.COACHING]: {
    expandedName: messages.COACHING,
    collapsedName: messages.COACHING,
    subMenuName: {
      [COACHING_SUB_MENU_LIST.COACHING_SESSIONS]: {
        expandedName: messages.COACHING_SESSIONS,
        collapsedName: messages.COACHING_SESSIONS,
      },
      [COACHING_SUB_MENU_LIST.MISSION_REVIEW]: {
        expandedName: messages.MISSION_REVIEW,
        collapsedName: messages.MISSION_REVIEW,
      },
      [COACHING_SUB_MENU_LIST.MISSION_AND_AI_ROLEPLAY_REVIEW]: {
        expandedName: messages.MISSION_AND_AI_ROLEPLAY_REVIEW,
        collapsedName: messages.MISSION_AND_AI_ROLEPLAY_REVIEW,
      },
      [COACHING_SUB_MENU_LIST.AI_ROLEPLAY_REVIEW]: {
        expandedName: messages.AI_ROLEPLAY_REVIEW,
        collapsedName: messages.AI_ROLEPLAY_REVIEW,
      },
    },
  },
  [NAVIGATION_MENU_LIST.ASSETS]: {
    expandedName: messages.ASSETS,
    collapsedName: messages.ASSETS,
    subMenuName: {
      [ASSETS_SUB_MENU_LIST.ASSETS_ASSETS]: {
        expandedName: messages.ASSETS_ASSETS,
        collapsedName: messages.ASSETS_ASSETS,
      },
      [ASSETS_SUB_MENU_LIST.ASSETS_MY_ASSETS]: {
        expandedName: messages.ASSETS_MY_ASSETS,
        collapsedName: messages.ASSETS_MY_ASSETS,
      },
      [ASSETS_SUB_MENU_LIST.ASSETS_INTERACTIONS]: {
        expandedName: messages.ASSETS_INTERACTIONS,
        collapsedName: messages.ASSETS_INTERACTIONS,
      },
    },
  },
  [NAVIGATION_MENU_LIST.CALL_AI]: {
    expandedName: messages.CALL_AI,
    collapsedName: messages.CALL_AI,
    subMenuName: {
      [CALL_AI_SUB_MENU_LIST.CALL_AI_RECORDINGS]: {
        expandedName: messages.CALL_AI_RECORDINGS,
        collapsedName: messages.CALL_AI_RECORDINGS,
      },
      [CALL_AI_SUB_MENU_LIST.CALL_AI_TEAM_RECORDINGS]: {
        expandedName: messages.CALL_AI_TEAM_RECORDINGS,
        collapsedName: messages.CALL_AI_TEAM_RECORDINGS,
      },
      [CALL_AI_SUB_MENU_LIST.CALL_AI_UPCOMING_MEETINGS]: {
        expandedName: messages.CALL_AI_UPCOMING_MEETINGS,
        collapsedName: messages.CALL_AI_UPCOMING_MEETINGS,
      },
      [CALL_AI_SUB_MENU_LIST.CALL_AI_MY_ANALYTICS]: {
        expandedName: messages.CALL_AI_MY_ANALYTICS,
        collapsedName: messages.CALL_AI_MY_ANALYTICS,
      },
      [CALL_AI_SUB_MENU_LIST.CALL_AI_PREFERENCES]: {
        expandedName: messages.CALL_AI_PREFERENCES,
        collapsedName: messages.CALL_AI_PREFERENCES,
      },
      [CALL_AI_SUB_MENU_LIST.CALL_AI_LIBRARIES]: {
        expandedName: messages.CALL_AI_LIBRARIES,
        collapsedName: messages.CALL_AI_LIBRARIES,
      },
      [CALL_AI_SUB_MENU_LIST.CALL_AI_ESSENTIALS]: {
        expandedName: messages.CALL_AI_ESSENTIALS,
        collapsedName: messages.CALL_AI_ESSENTIALS,
      },
    },
  },
  [NAVIGATION_MENU_LIST.DSR]: {
    expandedName: messages.DSR,
    collapsedName: messages.DSR,
    subMenuName: {
      [DSR_SUB_MENU_LIST.DSR_ROOMS]: {
        expandedName: messages.DSR_ROOMS,
        collapsedName: messages.DSR_ROOMS,
      },
      [DSR_SUB_MENU_LIST.DSR_TEMPLATES]: {
        expandedName: messages.DSR_TEMPLATES,
        collapsedName: messages.DSR_TEMPLATES,
      },
      [DSR_SUB_MENU_LIST.DSR_INSIGHTS]: {
        expandedName: messages.DSR_INSIGHTS,
        collapsedName: messages.DSR_INSIGHTS,
      },
      [DSR_SUB_MENU_LIST.DSR_DEALS]: {
        expandedName: messages.DSR_DEALS,
        collapsedName: messages.DSR_DEALS,
      },
      [DSR_SUB_MENU_LIST.DSR_SETTINGS]: {
        expandedName: messages.DSR_SETTINGS,
        collapsedName: messages.DSR_SETTINGS,
      },
    },
  },
  [NAVIGATION_MENU_LIST.SELLER_INTEL]: {
    expandedName: messages.SELLER_INTEL,
    collapsedName: messages.SELLER_INTEL,
    subMenuName: {},
  },
  [NAVIGATION_MENU_LIST.REVENUE_INTELLIGENCE]: {
    expandedName: messages.REVENUE_INTELLIGENCE,
    collapsedName: messages.REV_INTEL,
    subMenuName: {},
  },
  [NAVIGATION_MENU_LIST.PNC_ROLEPLAYS]: {
    expandedName: messages.PNC_ROLEPLAYS_PRACTICE,
    collapsedName: messages.PNC_ROLEPLAYS,
    subMenuName: {},
  },
  [NAVIGATION_MENU_LIST.TEAM_ANALYTICS]: {
    expandedName: messages.TEAM_ANALYTICS,
    collapsedName: messages.TEAM_ANALYTICS_SHORT,
    subMenuName: {
      [TEAM_ANALYTICS_SUB_MENU_LIST.TEAM_ANALYTICS_MY]: {
        expandedName: messages.TEAM_ANALYTICS_MY,
        collapsedName: messages.TEAM_ANALYTICS_MY,
      },
      [TEAM_ANALYTICS_SUB_MENU_LIST.TEAM_ANALYTICS_HIERARCHY_REPORTS]: {
        expandedName: messages.TEAM_ANALYTICS_HIERARCHY_REPORTS,
        collapsedName: messages.TEAM_ANALYTICS_HIERARCHY_REPORTS,
      },
      [TEAM_ANALYTICS_SUB_MENU_LIST.TEAM_ANALYTICS_RELATIONSHIP_REPORTS]: {
        expandedName: messages.TEAM_ANALYTICS_RELATIONSHIP_REPORTS,
        collapsedName: messages.TEAM_ANALYTICS_RELATIONSHIP_REPORTS,
      },
      [TEAM_ANALYTICS_SUB_MENU_LIST.TEAM_ANALYTICS_CALLAI]: {
        expandedName: messages.TEAM_ANALYTICS_CALLAI,
        collapsedName: messages.TEAM_ANALYTICS_CALLAI,
      },
      [TEAM_ANALYTICS_SUB_MENU_LIST.TEAM_ANALYTICS_COACHING]: {
        expandedName: messages.TEAM_ANALYTICS_COACHING,
        collapsedName: messages.TEAM_ANALYTICS_COACHING,
      },
      [TEAM_ANALYTICS_SUB_MENU_LIST.ANALYTICS_READINESS_INDEX]: {
        expandedName: messages.ANALYTICS_READINESS_INDEX,
        collapsedName: messages.ANALYTICS_READINESS_INDEX,
      },
    },
  },
  [NAVIGATION_MENU_LIST.DEALS]: {
    expandedName: messages.DEALS,
    collapsedName: messages.DEALS,
    subMenuName: {},
  },
};

export default navigationMessagesConfig;
